import * as React from 'react';

import {
    createInteractiveComponent,
    type InteractiveComponent,
} from './createInteractiveComponent';

/**
 * React hook to create an interactive component at runtime.
 * For example used in components depending on icons.
 */
export function useInteractiveComponent<E extends React.ComponentType>(
    Component: E
): InteractiveComponent<E>;
export function useInteractiveComponent<E extends React.ComponentType>(
    Component: E | undefined
): InteractiveComponent<E> | undefined {
    // TODO: use a global cache with WeakMap
    return React.useMemo(() => {
        return Component ? createInteractiveComponent(Component) : undefined;
    }, [Component]);
}
